import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
export function Scroll(_a) {
    var children = _a.children, style = _a.style;
    return (React.createElement(Scrollbars, { autoHide: true, style: style }, children));
}
